import * as React from 'react';

import { SVGProps } from '../../types';

export const IconAreasOfImprovementSvg = ({
  title,
  titleId,
  ...props
}: SVGProps) => (
  <svg
    width={72}
    height={72}
    viewBox="0 0 72 72"
    focusable="false"
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <rect x={16} y={7} width={49} height={64} rx={4} fill="#E4FBFF" />
    <rect
      x={11}
      y={2}
      width={49}
      height={64}
      rx={4}
      stroke="#0099C7"
      strokeWidth={2}
    />
    <path
      d="M32 36C32 34.8954 31.1046 34 30 34H23C21.8954 34 21 34.8954 21 36V52C21 53.1046 21.8954 54 23 54H32V36Z"
      stroke="#0099C7"
      strokeWidth={2}
    />
    <path
      d="M39 54H48C49.1046 54 50 53.1046 50 52V16C50 14.8954 49.1046 14 48 14H41C39.8954 14 39 14.8954 39 16V20.5"
      stroke="#0099C7"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <path
      d="M30 54H41V26C41 24.8954 40.1046 24 39 24H32C30.8954 24 30 24.8954 30 26V31"
      stroke="#0099C7"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <line
      x1={26}
      y1={24}
      x2={21}
      y2={24}
      stroke="#AFE3EF"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <line
      x1={35}
      y1={14}
      x2={21}
      y2={14}
      stroke="#AFE3EF"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
